/**
 * @generated SignedSource<<1c0e2f0662c2c4fcad2cb00147370079>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Currency = "USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type DisplaySettingsModal_user$data = {
  readonly id: string;
  readonly serviceId: string | null;
  readonly profile: {
    readonly currency: Currency | null;
  } | null;
  readonly " $fragmentType": "DisplaySettingsModal_user";
};
export type DisplaySettingsModal_user$key = {
  readonly " $data"?: DisplaySettingsModal_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"DisplaySettingsModal_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DisplaySettingsModal_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "39f49ddae74983cf28bdfe063a550b34";

export default node;
